module.exports = __webpack_public_path__ + "img/payments.893b8948.png";